import { render } from "./Care.vue?vue&type=template&id=94a892b0"
import script from "./Care.vue?vue&type=script&lang=js"
export * from "./Care.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__